export default __webpack_public_path__ + "static/media/restart.283ff19e.png";